import axios from "axios";
import helpers from "@/services/helpers";
export default {
  namespaced: true,
  state: {
    products: [],
    product: {},
    images: []
  },
  getters: {
    products: state => state.products,
    product: state => state.product,
    images: state => state.images
  },
  mutations: {
    setProducts(state, payload) {
      state.products = payload.data;
    },
    setProduct(state, payload) {
      state.product = payload.data
    },
    setProductImages(state, payload) {
      state.images = payload.data
    },
    setDestroyImage(state, payload) {
      state.images = state.images.filter(item => item.id !== payload)
    }
  },
  actions: {
    async get({ commit }, vm) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        if (vm) {
          let url = null
          url = `?paginated=true${vm.country ? '&country=' + vm.country : ''}${vm.currentPage ? '&page=' + vm.currentPage : ''}${vm.perPage ? '&per_page=' + vm.perPage : ''}${vm.company_id ? '&company_id=' + vm.company_id : ''}${vm.categories ? '&categories=' + vm.categories : ''}${vm.currency ? '&currency=' + vm.currency : ''}${vm.price_range_min ? '&price_range_min=' + vm.price_range_min : ''}${vm.price_range_max ? '&price_range_max=' + vm.price_range_max : ''}${vm.company ? '&company_id=' + vm.company : ''}${vm.search ? '&search=' + vm.search : ''}`
          const res = await axios.get(`/api/get-products${url ? url : ''}`);
          commit("setProducts", res.data);
          return res.data;
        } else {
          const res = await axios.get("/api/get-products");
          commit("setProducts", res.data);
          return res.data;
        }
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async getProduct({ commit }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.get(`/api/products/${id}`);
        commit("setProduct", res.data);
        return res.data;
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async createOrUpdate({ commit }, payload) {
      const { id } = payload;
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        if (!payload.id) {
          const resp = await axios.post("api/products", payload.data);
          return resp.data;
        } else {
          const res = await axios.post(
            `api/products/${payload.id}`,
            payload.data
          );
          return res.data;
        }
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async delete({ commit }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.delete(`api/products/${id}`);
        return res ? res.data : ''
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async saveExcel({ commit, dispatch }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const config = {
          header: {
            "Content-Type": "multipart/form-data"
          }
        };
        const data = new FormData();
        data.append("company_id", payload.company_id);
        data.append("file", payload.file);
        const res = await axios.post("/api/load_products_from_file", data, config);
        dispatch("get", { currentPage: 1, perPage: 10, company_id: payload.company_id });
        return res.data;
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },

    async galleryProduct({ commit, dispatch }, payload) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const config = {
          header: {
            "Content-Type": "multipart/form-data"
          }
        };
        const dataProduct = new FormData();
        dataProduct.append("product_id", payload.product_id);
        payload.gallery.forEach((e, index) => {
          dataProduct.append(`gallery[${index}]`, e);
        });
        const res = await axios.post("/api/gallery", dataProduct, config);
        dispatch("getImagesProduct", payload.product_id);
        return res.data;
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async getImagesProduct({ commit }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.get(`/api/gallery/${id}`);
        if (res !== undefined) {
          commit("setProductImages", res.data);
          return res.data;
        }
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
    async getDeleteImage({ commit }, id) {
      commit("config/SET_OVERLAY", true, { root: true });
      try {
        const res = await axios.delete(`api/gallery/${id}`);
        commit("setDestroyImage", id);
        return res.data;
      } catch (error) {

        throw error;
      } finally {
        commit("config/SET_OVERLAY", false, { root: true });
      }
    },
  }
};
